var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "additional-metaproperties" }, [
    _vm.isLoading
      ? _c(
          "div",
          { staticClass: "text-center" },
          [_c("b-spinner", { attrs: { variant: "primary" } })],
          1
        )
      : !_vm.hasError && (_vm.isRegularPublish || _vm.currentPlatformId)
      ? _c("div", { staticClass: "border rounded" }, [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-center p-2 cursor-pointer",
              on: {
                click: function ($event) {
                  _vm.isCollapsed = !_vm.isCollapsed
                },
              },
            },
            [
              _c("h6", { staticClass: "mb-0" }, [
                _vm._v("\n        Image Metadata\n      "),
              ]),
              _vm._v(" "),
              _c("i", {
                class: [
                  "fas",
                  _vm.isCollapsed ? "fa-chevron-down" : "fa-chevron-up",
                ],
              }),
            ]
          ),
          _vm._v(" "),
          !_vm.isCollapsed
            ? _c(
                "div",
                {
                  class: !_vm.isRegularPublish ? "metaproperties-content" : "",
                },
                [
                  _vm.inputProps.length
                    ? _c(
                        "div",
                        { staticClass: "row m-2" },
                        _vm._l(_vm.inputProps, function (prop) {
                          return _c(
                            "div",
                            { key: prop.id, staticClass: "col-md" },
                            [
                              _c("div", { staticClass: "mb-3" }, [
                                _c("label", [_vm._v(_vm._s(prop.label))]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedValues[prop.id],
                                      expression: "selectedValues[prop.id]",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: {
                                    value: _vm.selectedValues[prop.id],
                                  },
                                  on: {
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.selectedValues,
                                          prop.id,
                                          $event.target.value
                                        )
                                      },
                                      function ($event) {
                                        return _vm.updateInputValue(
                                          $event,
                                          prop.id
                                        )
                                      },
                                    ],
                                  },
                                }),
                              ]),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dateProps.length
                    ? _c(
                        "div",
                        { staticClass: "row m-2" },
                        _vm._l(_vm.dateProps, function (prop) {
                          return _c(
                            "div",
                            { key: prop.id, staticClass: "col-md-6" },
                            [
                              _c("div", { staticClass: "mb-3" }, [
                                _c("label", [_vm._v(_vm._s(prop.label))]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedValues[prop.id],
                                      expression: "selectedValues[prop.id]",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "date" },
                                  domProps: {
                                    value: _vm.selectedValues[prop.id],
                                  },
                                  on: {
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.selectedValues,
                                          prop.id,
                                          $event.target.value
                                        )
                                      },
                                      function ($event) {
                                        return _vm.updateDateValue(
                                          $event,
                                          prop.id
                                        )
                                      },
                                    ],
                                  },
                                }),
                              ]),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.multiselectProps.length
                    ? _c(
                        "div",
                        { staticClass: "row m-2" },
                        _vm._l(_vm.multiselectProps, function (prop) {
                          return _c(
                            "div",
                            { key: prop.id, staticClass: "col-md-6" },
                            [
                              _c(
                                "div",
                                { staticClass: "mb-3" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center justify-content-between mb-1",
                                    },
                                    [
                                      _c("label", { staticClass: "mb-0" }, [
                                        _vm._v(_vm._s(prop.label)),
                                      ]),
                                      _vm._v(" "),
                                      prop.name === _vm.bynder.PEPSI_GTIN &&
                                      _vm.selectedValues[prop.id] &&
                                      _vm.selectedValues[prop.id].length
                                        ? _c("img", {
                                            staticClass: "copy-icon",
                                            attrs: {
                                              src: "/img/icons/copy-icon.png",
                                              alt: "Copy",
                                              "data-toggle": "tooltip",
                                              "data-placement": "top",
                                              title: "Copy GTIN",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.copyToClipboard(
                                                  _vm.selectedValues[prop.id]
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("Multiselect", {
                                    attrs: {
                                      options: prop.options,
                                      multiple: true,
                                      taggable: true,
                                      "track-by": "id",
                                      label: "label",
                                      placeholder: prop.label,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.updateMultiSelectValue(
                                          $event,
                                          prop.id
                                        )
                                      },
                                      tag: function ($event) {
                                        return _vm.addNewTag($event, prop.id)
                                      },
                                    },
                                    model: {
                                      value: _vm.selectedValues[prop.id],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedValues,
                                          prop.id,
                                          $$v
                                        )
                                      },
                                      expression: "selectedValues[prop.id]",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectProps.length
                    ? _c(
                        "div",
                        { staticClass: "row m-2" },
                        _vm._l(_vm.selectProps, function (prop) {
                          return _c(
                            "div",
                            { key: prop.id, staticClass: "col-md-6" },
                            [
                              _c(
                                "div",
                                { staticClass: "mb-3" },
                                [
                                  _c("label", [_vm._v(_vm._s(prop.label))]),
                                  _vm._v(" "),
                                  _c("Multiselect", {
                                    attrs: {
                                      options: prop.options,
                                      multiple: false,
                                      taggable: true,
                                      "track-by": "id",
                                      label: "label",
                                      placeholder: prop.label,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.updateSelectValue(
                                          $event,
                                          prop.id
                                        )
                                      },
                                      tag: function ($event) {
                                        return _vm.addNewSelectTag(
                                          $event,
                                          prop.id
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.selectedValues[prop.id],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedValues,
                                          prop.id,
                                          $$v
                                        )
                                      },
                                      expression: "selectedValues[prop.id]",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }